
export default function HowToApply() {
  const steps = [
    {
      step: 1,
      title: 'Webからお申込み',
      description: '公式サイトの申込フォームから必要事項を入力して申込みます。在留カードをお持ちの方は専用ページからお申込みください。',
    },
    {
      step: 2,
      title: '審査・カード発行',
      description: '申込内容を確認後、審査が行われます。審査通過後、カードが発行されます。',
    },
    {
      step: 3,
      title: 'カードお受取り',
      description: 'ご自宅にカードが届きます。届いたカードの内容をご確認ください。',
    },
    {
      step: 4,
      title: 'デポジット支払い',
      description: '指定の銀行口座へデポジット（5万円〜200万円）をお支払いください。',
    },
    {
      step: 5,
      title: 'カード利用開始',
      description: 'デポジット入金確認後、カードがご利用いただけます。デポジット額が利用限度額となります。',
    },
    {
      step: 6,
      title: 'Web会員サービス登録',
      description: 'Web会員サービスに登録すると、利用明細の確認やポイント交換申込ができます。',
    },
  ];

  const documents = [
    '本人確認書類（運転免許証、マイナンバーカードなど）',
    '引き落とし口座情報（口座振替の場合）',
    '在留カード（外国籍の方）',
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-12 text-center">
          デポジット型クレジットカードの申込み方法
        </h2>

        <div className="space-y-4 mb-12">
          {steps.map((item) => (
            <div key={item.step} className="bg-[#F8F9FA] rounded-xl p-5 flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#0099CC] text-white font-bold rounded-full flex-shrink-0">
                {item.step}
              </div>
              <div>
                <h3 className="font-bold text-[#003366] mb-1">{item.title}</h3>
                <p className="text-gray-700 text-sm">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#E3F2FD] rounded-xl p-6">
          <h3 className="font-bold text-[#003366] mb-4 flex items-center gap-2">
            <i className="ri-file-list-3-line text-[#0099CC]"></i>
            申込みに必要なもの
          </h3>
          <ul className="space-y-2">
            {documents.map((doc, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-line text-[#0099CC]"></i>
                {doc}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
